import { render, staticRenderFns } from "./ViewRawMaterial.vue?vue&type=template&id=949ca16c&"
import script from "./ViewRawMaterial.vue?vue&type=script&lang=js&"
export * from "./ViewRawMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('949ca16c')) {
      api.createRecord('949ca16c', component.options)
    } else {
      api.reload('949ca16c', component.options)
    }
    module.hot.accept("./ViewRawMaterial.vue?vue&type=template&id=949ca16c&", function () {
      api.rerender('949ca16c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rawmaterials/AddProduct/ViewRawMaterial.vue"
export default component.exports